import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { productStore } from "@/store/ProductModule";
import { VariantFilterOptionsModel, Variant, TranslationModel, ProductFact, ProductModel } from "../models/product";
import cart from "../services/Cart";
import { SingleVariantFilter, DoubleVariantFilter, ConsumptionCalculator, QuantityCalculatorCastProductContainer, QuantityCalculatorMortarProductContainer,
    ConsumptionCalculatorSand, QuantityCalculatorUBlockProductContainer, CarbonSavingsCalculation } from "./";
import {QuantityCalculationResultModel} from "../models/QuanityCalculatorCast";
import calculatorService from "../services/CalculatorService";

import GoogleEnhancedEcommerce from "../services/GoogleEnhancedEcommerce";
import { SiteConstants } from "@/models/SiteConstants";

@Component({
    components: {
        SingleVariantFilter,
        DoubleVariantFilter,
        ConsumptionCalculator,
        QuantityCalculatorCastProductContainer,
        QuantityCalculatorMortarProductContainer,
        ConsumptionCalculatorSand,
        QuantityCalculatorUBlockProductContainer,
        CarbonSavingsCalculation,
    }
})
export default class VariantSelector extends Vue {
    protected product!: ProductModel;
    protected translations: TranslationModel;
    private variantFilterOptions: VariantFilterOptionsModel[];
    private readonly googleAnalyticsDimensionIdentifier: string;

    constructor() {
        super();
        this.translations = window.__finja.translations as TranslationModel;
        this.variantFilterOptions = window.__finja.preloadstate.product.variantFilterOptions;
        this.googleAnalyticsDimensionIdentifier = "ProductPage";
    }

    protected created() {
        this.product = productStore.product;
        if (Number(this.product.quantity) && this.product.quantity > 0) {
            this.quantity = this.product.quantity;
        }
    }

    protected mounted() {
        $(document).ready(() => {
            this.createImageGallery();
        });

        if (this.quantity === 0) {
            this.resetQuantitiesInputs();
        }
        this.setQuantityFromSession();
        this.setQuantityFromSessionMortar();
        this.setQuantityFromSessionFloor();
        this.setQuantityFromSessionBlock();
        this.setQuantityFromSessionUBlock();
        this.setQuantityFromSessionCarbonSavingsProduct();
        this.ReportViewToGoogleEnhancedEcommerce();
    }

    protected addToShoppingList() {
        window.Accelerator.libs.cart.addToShoppingList({
            quantity: this.quantity,
            variantId: this.variant.variantId,
            variantSystemId: this.variant.variantSystemId
        });

        this.ReportAddToCartToGoogleEnhancedEcommerce(true);
    }

    protected mapToEvent() {
        if (this.isProductWebShop) {
            this.addToShoppingList();
        } else {
            this.addToCart();
        }
    }

    @Watch("variantId")
    private onVariantIdChange(value: string, oldValue: string) {
        this.updateQuantityToPallet(false);
        this.ReportViewToGoogleEnhancedEcommerce();

        $(document).ready(_ => this.pickPhotoOfSelectedVariant(value));
        this.setQuantityFromSession();
        this.setQuantityFromSessionMortar();
        this.setQuantityFromSessionFloor();
        this.setQuantityFromSessionBlock();
        this.setQuantityFromSessionUBlock();
    }

    @Watch("quantity")
    private onQuantityChange(value: number, oldValue: number) {
        const itemInPallet = this.variant.itemSecondaryPackagingContent;
        if (!Number(itemInPallet)) {
            return;
        }

        this.palletRequired = Math.floor(this.quantity / itemInPallet);

        if (this.isCarbonSavingsCalculationVariant) {
            calculatorService.storeSessionQuantity("carbonsavingsproductquantity", this.quantity);
        }
    }

    private setQuantityFromSession() {
        const castquantity = this.getSession("castquantity");
        if (castquantity !== "") {
            this.setQuantityFromSessionJson(castquantity);
        }
    }

    private setQuantityFromSessionMortar() {
        const mortarquantity = this.getSession("mortarquantity");
        if (mortarquantity !== "") {
            this.setQuantityFromSessionJson(mortarquantity);
        }
    }

    private setQuantityFromSessionFloor() {
        const floorquantity = this.getSession("floorquantityBag");
        const floorquantityPlaster = this.getSession("floorquantityPlaster");
        if (floorquantity !== "" && this.variant.itemConsumptionCalculatorBag) {
            this.setQuantityFromSessionJson(floorquantity);
        }
        if (floorquantityPlaster !== "" && this.variant.itemConsumptionCalculatorPlaster) {
            this.setQuantityFromSessionJson(floorquantityPlaster);
        }
    }

    private setQuantityFromSessionBlock() {
        const blockquantity = this.getSession("blockquantity");
        if (blockquantity !== "") {
            this.setQuantityFromSessionJson(blockquantity);
        }
    }

    private setQuantityFromSessionUBlock() {
        const insulationQuantity = this.getSession("ublockinsulationquantity");
        const fillingQuantity = this.getSession("ublockfillingquantity");
        if (insulationQuantity !== "") {
            this.setQuantityFromSessionJson(insulationQuantity);
        }

        if (fillingQuantity !== "") {
            this.setQuantityFromSessionJson(fillingQuantity);
        }
    }

    private setQuantityFromSessionJson(quantityResults: string) {
        const quantityCalcResults = JSON.parse(quantityResults);
        if (quantityCalcResults !== undefined) {
            const currentVariantData = quantityCalcResults.filter((x: QuantityCalculationResultModel)  => x.variantId === this.variant.variantId);
            if (currentVariantData.length > 0 && Number(currentVariantData[0].sack) && currentVariantData[0].sack > 0) {
                this.quantity = currentVariantData[0].sack;
            }
        }
    }

    private setQuantityFromSessionCarbonSavingsProduct() {
        if (this.isCarbonSavingsCalculationVariant) {
            const quantity = this.getSession("carbonsavingsproductquantity");
            if (quantity !== "") {
                this.quantity = JSON.parse(quantity);

                if (this.quantity === 0) {
                    this.quantity = 1;
                }
            }
        }
    }

    private ReportViewToGoogleEnhancedEcommerce() {
        const gee = new GoogleEnhancedEcommerce();
        gee.PushViewToGoogle(
            this.variant.variantName,
            this.variant.variantId,
            this.variant.priceValue,
            this.variant.category
        );
    }

    private ReportAddToCartToGoogleEnhancedEcommerce(isShoppingList: boolean = false) {
        const gee = new GoogleEnhancedEcommerce();
        gee.PushAddToCartToGoogle(
            this.variant.variantName,
            this.variant.variantId,
            this.variant.priceValue,
            this.variant.category,
            this.quantity,
            this.googleAnalyticsDimensionIdentifier,
            this.variant.currencyCode,
            isShoppingList,
        );
    }

    get quantity(): number {
        return productStore.quantity;
    }

    set quantity(value: number) {
        productStore.dispatchQuantity(value);
    }

    get palletRequired(): number {
        return productStore.palletRequired;
    }

    set palletRequired(value: number) {
        productStore.dispatchPalletRequired(value);
    }

    get variants(): Variant[] {
        return productStore.variants;
    }

    get variant(): Variant {
        return productStore.variant;
    }

    set variant(value: Variant) {
        productStore.dispatchVariant(value);
    }

    get variantId() {
        return this.variant.variantId;
    }

    set variantId(value: string) {
        this.variant = this.variants.find(x => x.variantId === value) || this.variant;
    }

    get hasVariants(): boolean {
        return this.variants.length > 1;
    }

    get singleVariantFilter(): boolean {
        return this.variantFilterOptions.length === 1;
    }

    get doubleVariantFilter(): boolean {
        return this.variantFilterOptions.length === 2;
    }

    get buyButtonDisabled(): boolean {
        return this.quantity < 1;
    }

    get isCarbonSavingsCalculationVariant(): boolean {
        return this.variant.carbonSavingsModel && this.variant.carbonSavingsModel.savingsComparedToNonECOVariant > 0;
    }

    get isProductWebShop(): boolean {
        return window.site.settings.activateProductWebshop === "true";
    }
    private addToCart() {
        if (this.buyButtonDisabled) {
            return;
        }

        cart.addToCart({
            quantity: this.quantity,
            variantId: this.variant.variantId,
            variantSystemId: this.variant.variantSystemId
        });

        this.ReportAddToCartToGoogleEnhancedEcommerce();
    }

    private createImageGallery(): void {
        const self = this;
        const slider = $(".slider-for");
        /*slider.on("init", () => {
            this.filterImageGallery(productStore.variant.variantId);
        });*/
        slider.slick({
            // slidesToShow: 1,
            // slidesToScroll: 1,
            arrows: false,
            // fade: true,
            infinite: false,
            asNavFor: ".slider-nav",
            lazyLoad: "ondemand"
        }).on("afterChange", (event, slick, currentSlide, nextSlide) => {
            const slideCurrent = $(slick.$slides).filter(".slick-current");
            const variantIdElement = slideCurrent.find("[data-variantid]");
            const variantId: string = variantIdElement.data("variantid").toString();
            if (variantId !== self.variantId) {
                self.variantId = variantId;
            }
        });
        $(".slider-nav").slick({
            // slidesToShow: 4,
            // slidesToScroll: 1,
            arrows: true,
            centerMode: false,
            asNavFor: ".slider-for",
            focusOnSelect: true,
            infinite: false,
            variableWidth: true
        });
        (slider as any).slickLightbox({
            itemSelector: "div > a",
            imageMaxHeight: 2.7,
            lazy: true
        });

        this.pickPhotoOfSelectedVariant(productStore.variant.variantId);
        $(".js-slick-container").css("visibility", "visible");

        // Make element visible after all script render
        slider.css("visibility", "visible");
        $(".slider-nav").css("visibility", "visible");
    }

    private pickPhotoOfSelectedVariant(selectedVariant: string): void {
        $("div.slider-nav div[data-variantid]").each(function(): void {
            if ($(this).data("variantid").toString() === selectedVariant) {
                const i = $(this).parent().parent().data("slick-index");
                $(".slider-for").slick("slickGoTo", i, true);
                return;
            }
        });
    }

    private resetQuantitiesInputs(): void {
        const itemsInPallet: number = this.variant.itemSecondaryPackagingContent;

        if (this.variant.showPalletQuantity) {
            this.quantity = itemsInPallet;
            this.palletRequired = this.product.quantityDefault;
        } else {
            this.quantity = this.product.quantityDefault;
            this.palletRequired = Math.floor(this.quantity / itemsInPallet);
        }
    }

    /**
     * Calculates and sets the quantity with regards to the selected variant's
     * secondary packaging (pallet) settings.
     * @param calculateQuantityRemainder - Exclude remainder for pallet and quantity
     */
    private updateQuantityToPallet(calculateQuantityRemainder: boolean = true, resetQuantity: boolean = false): void {
        const quantity = this.quantity;
        const quantityPerPallet = this.variant.itemSecondaryPackagingContent;
        let quantityMod = 0;

        if (this.variant.showQuantity && calculateQuantityRemainder) {
            quantityMod = quantity % quantityPerPallet;
        }

        if (this.variant.showPalletQuantity) {
            this.palletRequired = this.palletRequired - (this.palletRequired % 1);
            if (this.palletRequired <= 0) {
                this.palletRequired = 1;
            }
            this.quantity = (quantityPerPallet * this.palletRequired);
        }

        if (!resetQuantity) {
            if (this.variant.itemConsumptionCalculatorBlock && this.getSession(this.variant.baseProductArticleNumber + SiteConstants.Area)) {
                const area  = JSON.parse(this.getSession(this.variant.baseProductArticleNumber + SiteConstants.Area));
                this.quantity = Math.ceil(area * this.variant.itemMaterialConsumption);
            } else if (this.getSession(this.variant.baseProductArticleNumber + SiteConstants.Area) && this.getSession(this.variant.baseProductArticleNumber + SiteConstants.Layer)) {
                const area  = JSON.parse(this.getSession(this.variant.baseProductArticleNumber + SiteConstants.Area));
                const layer  = JSON.parse(this.getSession(this.variant.baseProductArticleNumber + SiteConstants.Layer));
                const material = area * layer;
                const kgNeeded = material * this.product.productMaterialConsumption;
                this.quantity = Math.ceil(kgNeeded / this.variant.itemPrimaryPackagingWeight);
            }
        }
    }

    private shouldQuantityBeReadonly(): boolean {
        if (!this.variant.showQuantity && this.variant.showPalletQuantity) {
            return true;
        } else {
            return false;
        }
    }

    private getSession(key: string): string {
        if (typeof(sessionStorage) !== "undefined") {
            return sessionStorage.getItem(key) || "";
        }

        return "";
    }
}
